import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';

export default function Layout() {
  const { lang } = useParams();
  return (
    <>
      <Header lang={lang} />
      <main>
        <Outlet />
      </main>
      <Footer lang={lang} />
      <CookieBanner />
    </>
  );
}
